import "lazyloadxt/dist/jquery.lazyloadxt.min.js";

$(".lazy").lazyLoadXT({
    //throttle: 0,
    //edgeY: 400,
    blankImage: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
});

